<template>
  <form>
    <div class="row" v-for="f in fields" :key="f.field">
      <label class="col-4">{{ f.title }}</label>
      <!-- INT -->
      <div class="col-4" v-if="f.type === 'int'">
        <div class="input-group">
          <input
            type="number"
            class="form-control"
            v-model.number="v[f.field]"
            step="1"
          />
          <span class="input-group-text" v-if="f.units">{{ f.units }}</span>
        </div>
      </div>
      <!-- SELECT -->
      <div class="col-6" v-if="f.type === 'select'">
        <select class="form-control" v-model="v[f.field]">
          <option v-for="o in f.options" :value="o.key" :key="o.key">
            {{ o.text }}
          </option>
        </select>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    fields: Array,
    value: Object,
  },
  computed: {
    v: {
      get: function () {
        let v = {};
        this.fields.forEach((f) => {
          if (this.value[f.field]) {
            v[f.field] = this.value[f.field];
          } else if (f.default) {
            v[f.field] = f.default;
          } else {
            v[f.field] = null;
          }
        })
        return v
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  //   created() {
  //     this.fields.forEach((f) => {
  //       console.log(f);
  //       if (f.default) {
  //         this.item[f.field] = f.default;
  //       }
  //     });
  //   },
};
</script>